import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NguCarousel, NguCarouselConfig } from '@ngu/carousel';
import { ToastrService } from 'ngx-toastr';
import { first, interval, Subscription } from 'rxjs';
import { Constant, DefaultGUID, DefaultLatLngCoordinates, LegDetailStatus, ServiceTypeNames } from 'src/app/@shared/constants/Constant';
import { CheckListDetailsComponent } from 'src/app/MaterialDialogs/check-list/check-list-details/check-list-details.component';
import { CheckListService } from 'src/app/MaterialDialogs/check-list/check-list-service.service';
import { TransportType } from 'src/app/ReusableComponent/map/model/map.model';
import { IGetCheckListModel } from 'src/app/model/checkList.model';
import { IFlightLocationDetails } from 'src/app/model/flightTracking.model';
import { FlightTrackingService } from 'src/app/service/flight-tracking.service';
import { ItineraryService } from 'src/app/service/itinerary.service';
import { LocationService } from 'src/app/service/location.service';
import { MapMarkerService } from 'src/app/service/map-marker.service';
import { ViewMemberModel } from 'src/app/service/memeber.model';
import { IGetLocationViewModel } from 'src/app/service/vehicle.model';
import * as timeZones from 'src/assets/api-data/timezoneList.json';
import { environment } from 'src/environments/environment';
import { MemberService } from '../../service/member.service';
import { ServiceRequestTemplate, ServiceType } from '../../service/service-request';
import { ServiceRequestService } from '../../service/service-request.service';
import { PickUpEnum } from '../../shared/enums/pick-up.enum';
import { SchedulingTypeEnum } from '../../shared/enums/scheduling-type.enum';
import { ITimeZoneModel } from '../../model/common.model';
import { TimezoneHttpService } from '@services/timezone/timezone-http.service';
import { TimezoneInterface } from '@interfaces/timezone/timezone.interface';
import { TimezoneSharedService } from '@services/timezone/timezone-shared.service';
import { CURRENT_TIMEZONE } from '@properties/local-storage.properties';
import { LocalStorageService } from '@services/local-storage.service';
import { TimezoneShortEnum } from '@enums/timezone/timezone-short.enum';
import { UserTimezoneInterface } from '@interfaces/timezone/user-timezone.interface';
import { canShowOrTime } from '@helpers/service-request.helper';
import { ServiceRequestStatusEnum } from '@enums/service-request-status.enum';
import { ILegTimeStampViewModel } from 'src/app/model/service-request-model';
import { EventConstant } from 'src/app/sse/event.constant';
import { SignalrService } from 'src/app/sse/signalr.service';
import { ServiceTypeEnum } from '@enums/service-type.enum';
import { UserRoleEnum } from '@enums/user-role.enum';

declare var google: any;
declare var $: any;

@Component({
  selector: 'app-track-itinerary',
  templateUrl: './preview-itinerary-detail.component.html',
  styleUrls: ['./preview-itinerary-detail.component.css'],
})
export class PreviewItineraryDetailComponent implements OnInit, OnDestroy {
  @ViewChild('presrcdesCarousel', { static: false }) presrcdesCarousel: NguCarousel<any>;
  @ViewChild('mapContainer', { static: false }) gmap: ElementRef;

  readonly serviceRequestTypeEnum = ServiceTypeEnum;
  readonly schedulingTypeEnum = SchedulingTypeEnum;

  // TODO: Need To remove any type from this file.
  subCustomerName: string;
  private _getLocationSubscription: Subscription = new Subscription();
  private _subscriptions: Subscription = new Subscription();
  timeZone: any;
  internalMemberBusinessUnitId: string = '9087d2f4-14be-48a2-b1ac-fe1c19f4965b';
  url = `${environment.baseUrl}`;
  nameOfFile: string;
  currentOrigin: any;
  currentDestination: any;
  oldDate;
  upcomingDate;
  loader = true;
  actualDoorToDoorTime: any;
  estimatedSourceTime: number;
  actualSourceTime: number;
  estimatedDestinationTime: number;
  actualDestinationTime: number;
  currentDate;
  running;
  upcomeDate;
  completedDate;
  notesType: string = '';
  serviceRequestId: any;
  urlData: any;
  teamMemberDetails = {
    memberName: '',
    phoneNumber: '',
    dob: '',
    weight: '',
    memberAddress: '',
    gender: '',
  };
  timeZones: ITimeZoneModel[] = [];
  timezoneConfig = {
    displayKey: 'title',
    search: true,
    placeholder: 'Select Timezone',
    height: '400px',
  };
  teamDetails: any = [];
  prevlnglat = null; //used in getLegLocation method to store previous location coordinates
  sr_status: string;
  map?: google.maps.Map;
  user: ViewMemberModel = {
    addressId: DefaultGUID,
    businessUnitId: DefaultGUID,
    city: null,
    dateOfBirth: null,
    description: null,
    designation: null,
    designationId: null,
    addressLocationType: null,
    emailID: null,
    files: null,
    firstName: null,
    height: null,
    isActive: null,
    isEnable: null,
    isGlobal: null,
    isGuestUser: null,
    lastName: null,
    memberId: null,
    memberType: null,
    middleName: null,
    name: null,
    organizationType: null,
    organizationTypeId: null,
    password: null,
    phoneNumber: null,
    profile: null,
    role: null,
    roleId: null,
    state: null,
    stateId: null,
    streetAddress: null,
    userName: null,
    weight: null,
    zipcode: null,
    assignedRoleList: [],
    gender: null,
    isCode3Certification: false,
    jobTitle: '',
  };
  selectedTimezone: TimezoneInterface | null = null;
  isInternalReadOnly: boolean = false;
  isAdmin: boolean = false;
  value: any;
  legList: any;
  specialInstructions: any;
  SpecialInstructionCount: any = 0;
  notes: any = [];
  legId: any;
  isModelOpen: boolean = false;
  HideMe: any = [];
  isLegDetailHidden: any = [];
  showLegDetail: any = [];
  legIdList: string[] = [];
  showHideText = 'Expand All';
  latlngbounds = new google.maps.LatLngBounds();
  markerOrigin = new google.maps.Marker({
    position: new google.maps.LatLng(36.778259, -119.417931),
    map: this.map,
    title: 'Corporate Technology Solutions',
    icon: {
      path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
      strokeColor: 'yellow',
      scale: 2,
    },
  });
  markerDestination = new google.maps.Marker({
    position: new google.maps.LatLng(35.860119, -86.660156),
    map: this.map,
    title: 'Banner University Medical Center',
    icon: {
      path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
      strokeColor: 'red',
      scale: 2,
    },
  });
  currentMarker;
  cabicon = './assets/img/icon.ico';
  LegOrigin: any;
  LegDestination: any;
  distance: any;
  duration: any;
  carouselTileItems: Array<any> = [];
  carouselList: Array<any> = [];
  carouselTile: NguCarouselConfig = {
    grid: { xs: 1, sm: 1, md: 2, lg: 2, all: 0 },
    slide: 1,
    speed: 250,
    point: {
      visible: true,
    },
    load: 2,
    velocity: 0,
    touch: true,
    easing: 'cubic-bezier(0, 0, 0.2, 1)',
  };
  ServiceList: ServiceRequestTemplate = {
    srStatus: '',
    coordinatorId: '',
    coordinatorName: '',
    customerInfo: {
      customerName: '',
      businessUnitId: '',
      memberId: '',
      contactId: '',
      numberType: '',
      phoneNumber: '',
      subCustomerId: '',
      subCustomerMemberId: null,
      subCustomerMemberPhoneNumber: null,
      subCustomerMemberContactId: null,
      subCustomerMemberNumberType: null,
      subCustomer: null,
    },
    serviceInfo: {
      cateringOptionsString: null,
      priority: false,
      region: '',
      status: '',
      serviceType: null,
      pickUpTime: PickUpEnum.Immediate,
      serviceSubType: [],
      additionalEquipmentType: [],
      transmedics: null,
      startTime: new Date(),
      inBoundETA: new Date(),
      outBoundETA: new Date(),
      orTime: null,
      isCode3: true,
      unos: '',
      tissueId: '',
      matchId: '',
      internalReferenceId: '',
      mediGoTrackerNumber: '',
      airSpaceJobID: '',
      airSpacetrackingID: '',
      dropOffLocation: DefaultGUID,
      personnelService: DefaultGUID,
      teamDetails: [
        {
          teamMember: {
            memberId: DefaultGUID,
            name: '',
          },
          teamAddress: {
            addressId: DefaultGUID,
            name: '',
          },
          memberId: DefaultGUID,
          phoneNumberId: DefaultGUID,
          addressId: DefaultGUID,
          phoneNumberType: 'Work',
          dob: new Date(),
          weight: 0,
          phoneNumber: '',
          gender: null,
        },
      ],
      plannedEndTime: new Date(),
      actualEndTime: new Date(),
      destination: [
        {
          destinationAddressID: '',
          destinationMemberId: '',
          destinationPhoneNumberId: '',
          numberType: '',
          destinationPhoneNumber: '',
          endTime: null,
          destination: '',
          destinationAddress: '',
          destinationAddressLocation: '',
          destinationMember: '',
          destinationSequenceNumber: 0,
          destinationAirportCode: null,
          destinationAccessType: null,
        },
      ],
      catering: false,
      cateringOptions: [],
      cateringNotes: null,
      donorType: null,
      schedulingType: SchedulingTypeEnum.PickupTime,
      scheduledArrivalTime: new Date().toISOString(),
      scheduledPickupTime: new Date().toISOString(),
      hotStandbyTime: new Date().toISOString(),
      isStartTimeTBD: false,
      isEndTimeSameAsORTime: false,
      jobType: null,
      deviceRegistrationNumber: null,
      airwayBill: null,
      trackingLink: null,
    },
    tripInfo: {
      originAddressID: '',
      specialInstruction: [
        {
          appCategoryId: DefaultGUID,
          category: '',
          instruction: '',
        },
      ],
      transportType: '',
      templateName: '',
      originContactName: '',
      destinationAddressType: null,
      originAddressType: null,
      originAirportCode: null,
      isOriginLocationTBD: false,
      isDestinationLocationTBD: false,
    },
    note: [],
    files: [],
    serviceRequestId: '',
    saveAsTemplate: false,
    createdOn: new Date(),
    createdBy: '',
    tripId: '',
    legDetails: [],
    serviceRequestLinkId: '',
  };
  serviceType: string;
  ortime: any;
  serviceOriginLocations: IGetLocationViewModel[];
  serviceDestinationLocations: IGetLocationViewModel[];
  isCode3: boolean;
  createdOn: any;
  customerSelectedId: any;
  customerSelected: any;
  serviceTypes: ServiceType[];
  serviceisCode3: any;
  legListCount: any;
  start_Time: any;
  scheduledArrivalTime: string | null = null;
  end_Time: any;
  customerContactId: any;
  planEndTime: any;
  actualEndTime: any;
  legPlannedDuration: any[] = [];
  legActualDuration: any[] = [];
  itiMapMarkers = [];
  labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  totalDistance = 0;
  totalDuration = 0;
  callFlowDetailsEndPoint = 'call-flow-details';
  serviceTypeId: string;
  readonly serviceRequestStatusEnum: typeof ServiceRequestStatusEnum = ServiceRequestStatusEnum;
  plane_departure_img = '../../assets/img/plane_departure_img.png';
  plane_arrival_img = '../../assets/img/plane_arrival_img.png';
  serviceTypeNames = ServiceTypeNames;
  timeStamp: { Status: string; Time: Date; hide: boolean }[] = [];
  timezones = this.timezoneService.timezonesList;
  protected readonly canShowOrTime = canShowOrTime;

  constructor(
    private readonly _route: ActivatedRoute,
    private readonly _serviceRequestService: ServiceRequestService,
    private readonly _toastr: ToastrService,
    private readonly _router: Router,
    private readonly _memberService: MemberService,
    private readonly _datepipe: DatePipe,
    private readonly _locationService: LocationService,
    private readonly _itineraryService: ItineraryService,
    private readonly _dialog: MatDialog,
    private readonly _checklistService: CheckListService,
    private readonly _flightTrackingService: FlightTrackingService,
    private readonly _mapMarkerService: MapMarkerService,
    private readonly timezoneHttpService: TimezoneHttpService,
    private readonly timezoneService: TimezoneSharedService,
    private readonly localStorageService: LocalStorageService,
    private readonly signalRService: SignalrService,
  ) {
    this._subscriptions.add(this._route.params.subscribe((params) => (this.serviceRequestId = params)));
    this._subscriptions.add(
      this._route.queryParams.subscribe((queryParam) => {
        if (queryParam != null || queryParam != undefined) {
          this.sr_status = queryParam.service_request_status;
        }
      }),
    );
    this.urlData = this.serviceRequestId.PageName;
    this.serviceRequestId = this.serviceRequestId.serviceRequestId;
    this._subscriptions.add(
      this._serviceRequestService.timZoneChange.subscribe((value) => {
        this.timeZone = Constant.selectedTimeZoneShortValue;
      }),
    );
    this.timeZone = Constant.selectedTimeZoneShortValue;
  }

  ngOnInit(): void {
    this.timeZones = (timeZones as any).default;
    const loggedInUser = JSON.parse(localStorage.getItem('user'));
    if (loggedInUser != null && loggedInUser != undefined) {
      this.user = loggedInUser;
      this.isInternalReadOnly = this.user.role === UserRoleEnum.INTERNAL_READONLY;
      this.isAdmin =
        this.user.role === UserRoleEnum.EXECUTIVE_ADMIN ||
        this.user.role === UserRoleEnum.MANAGEMENT ||
        this.user.role === UserRoleEnum.COORDINATOR ||
        this.user.role === UserRoleEnum.ACCOUNTING ||
        this.isInternalReadOnly;
    } else {
      this.user.role = UserRoleEnum.OUTSIDE_ORG;
    }
    this.getAllServiceLocations();
    this.getServiceRequestDetail(this.serviceRequestId);
    this.carouselTileLoad();
    this.currentDate = new Date();
    this.running = new Date();
    this.upcomingDate = new Date();
    this.upcomeDate = new Date();
    this.completedDate = new Date();
    var d = new Date();
    this.showLegdetails('1', 'Bidid');
    this.oldDate = d.setDate(d.getDate() - 1);
    this.upcomingDate = d.setDate(d.getDate() + 1);
    this.running = this.AddMinutesToDate(this.currentDate, 24);
    this.upcomeDate = this.AddMinutesToDate(this.currentDate, 24);
    this.completedDate = this.MinutesToDate(this.currentDate, 150);

    this.getUserTimezone();
    this.changeLegStatusEventListener();
  }

  ngOnDestroy(): void {
    this.clearGetLocationInterval();
    this._subscriptions.unsubscribe();
  }

  changeLegStatusEventListener(): void {
    this.signalRService.sseEventListener(EventConstant.changeLegStatusEvent);
    this._subscriptions.add(
      this.signalRService.eventDataChange.subscribe((value) => {
        if (value.eventName == EventConstant.changeLegStatusEvent) {
          if (!this.legList) {
            return;
          }
          const eventData = value.data;
          let legIndex = this.legList.findIndex((sr) => sr.legId == eventData.legId);
          if (legIndex != -1) {
            this.legList[legIndex].status = eventData.legStatus;
            this.legList[legIndex].plannedStartTime = eventData.legTimeStamp.plannedDate;
            this.legList[legIndex].plannedEndTime = eventData.legTimeStamp.plannedEndTime;
            this.legList[legIndex].actualStartTime = eventData.legTimeStamp.actualDate;
            this.legList[legIndex].actualEndTime = eventData.legTimeStamp.actualEndTime;
            this.legTimeStampData(eventData.legStatusTimeStamp as ILegTimeStampViewModel, eventData.stepTransportType);
            if (eventData.legStatus == LegDetailStatus.driverDone && this.legList.some((leg) => leg.status == LegDetailStatus.notStarted)) {
              this.getLegDetail({
                serviceRequestId: [this.serviceRequestId],
              });
            }
          }
        }
      }),
    );
  }

  legTimeStampData(legStatusTimeStamp: ILegTimeStampViewModel, legType: string): void {
    this.timeStamp = [];
    if (legType != 'Air' && legStatusTimeStamp.enroutetime != null)
      this.timeStamp.push({ Status: LegDetailStatus.enroute, Time: legStatusTimeStamp.enroutetime, hide: true });
    if (legStatusTimeStamp.onSceneTime != null)
      this.timeStamp.push({
        Status: legType == 'Air' ? LegDetailStatus.onBoard : LegDetailStatus.onScene,
        Time: legStatusTimeStamp.onSceneTime,
        hide: true,
      });
    if (legStatusTimeStamp.pickupTime != null)
      this.timeStamp.push({
        Status: legType == 'Air' ? LegDetailStatus.wheelsUp : LegDetailStatus.pickedUp,
        Time: legStatusTimeStamp.pickupTime,
        hide: true,
      });
    if (legStatusTimeStamp.dropOffTime != null)
      this.timeStamp.push({
        Status: legType == 'Air' ? LegDetailStatus.landed : LegDetailStatus.droppedOff,
        Time: legStatusTimeStamp.dropOffTime,
        hide: true,
      });
    if (legStatusTimeStamp.jobDoneTime != null)
      this.timeStamp.push({ Status: LegDetailStatus.jobDone, Time: legStatusTimeStamp.jobDoneTime, hide: true });
    if (legStatusTimeStamp.driverDoneTime != null)
      this.timeStamp.push({ Status: LegDetailStatus.driverDone, Time: legStatusTimeStamp.driverDoneTime, hide: true });
  }

  selectTimeZone(event: { value: TimezoneInterface }): void {
    this.selectedTimezone = event.value;
    this.timezoneService.selectedTimezone = this.selectedTimezone;

    // todo: for the back compatibility
    Constant.selectedTimeZone = this.selectedTimezone.localTime;
    Constant.selectedTimeZoneShortValue = this.selectedTimezone.title;
    Constant.selectedGMTValue = this.selectedTimezone.gmt;
    Constant.selectedOffsetTime = this.selectedTimezone.offset.toString();
    this._serviceRequestService.timZoneChange.next(Constant.selectedTimeZoneShortValue);

    this.localStorageService.setValue(CURRENT_TIMEZONE, JSON.stringify(event.value));
  }
  AddMinutesToDate(date, minutes) {
    return new Date(date.getTime() + minutes * 60000);
  }
  MinutesToDate(date, minutes) {
    return new Date(date.getTime() - minutes * 600);
  }
  createItinerary(ServiceRequestId) {
    this._router.navigate(['/itinerary/' + ServiceRequestId]);
  }
  goBack() {
    switch (this.urlData) {
      case 'ServiceRequest':
        this._router.navigate(['/service-request']);
        break;
      case 'Dashboard':
        this._router.navigate(['/service-request']);
        break;
      case 'DriverDashboard':
        this._router.navigate(['/driver-dashboard']);
        break;
      case 'CustomerDashboard':
        this._router.navigate(['/v2/customer-dashboard']);
        break;
      case 'VendorDashboard':
        this._router.navigate(['/vendor-dashboard']);
        break;
      case 'Report':
        this._router.navigate(['/customer-report/report']);
        break;
    }
  }
  editRequest(serviceRequestId) {
    this._router.navigate(['/edit-service-request/' + serviceRequestId]);
  }

  openAddFileNotesPopup(id) {
    this.isModelOpen = true;
    this.legId = id;
  }
  noteModelClose() {
    this.isModelOpen = false;
  }
  showLegdetails(level1, tbl) {
    this.showLegDetail[level1] = !this.showLegDetail[level1];
    this.isLegDetailHidden[level1] = !this.isLegDetailHidden[level1];
    this.HideMe[level1] = !this.HideMe[level1];
  }
  showHideAll(showHideText) {
    if (showHideText == 'Collapse All') {
      for (let i = 0; i < this.legList.length; i++) {
        this.showLegDetail[i + 1] = false;
        this.HideMe[i + 1] = false;
      }
      this.showHideText = 'Expand All';
    } else {
      for (let i = 0; i < this.legList.length; i++) {
        this.showLegDetail[i + 1] = true;
        this.HideMe[i + 1] = true;
      }
      this.showHideText = 'Collapse All';
    }
  }
  ngAfterViewInit() {
    this.mapInitializer();
  }
  mapInitializer() {
    const mapOptions = {
      center: new google.maps.LatLng(DefaultLatLngCoordinates.latitude, DefaultLatLngCoordinates.longitude),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };
    this.map = new google.maps.Map(this.gmap.nativeElement, mapOptions);
    this.latlngbounds.extend(this.markerOrigin.position);
    this.latlngbounds.extend(this.markerDestination.position);
    this.map.setCenter(this.latlngbounds.getCenter());
    this.map.fitBounds(this.latlngbounds);
  }
  clearGetLocationInterval() {
    this._getLocationSubscription.unsubscribe();
  }

  reinitializeGetLocationSubscription() {
    this.clearGetLocationInterval();
    this._getLocationSubscription = new Subscription();
  }

  startGetLocationInterval(legId, transportType) {
    this.reinitializeGetLocationSubscription();
    this._getLocationSubscription.add(
      interval(3000).subscribe((val) => {
        this.getLegLocation(legId, transportType);
      }),
    );
  }
  getLegLocation(legId: string, transportType: string) {
    let currentLocation;
    this._itineraryService.getCurrentLegLocation(legId).subscribe((response) => {
      currentLocation = response;
      if (currentLocation != null && currentLocation.latitude && currentLocation.longitude) {
        const curlnglat = new google.maps.LatLng(parseFloat(currentLocation.latitude), parseFloat(currentLocation.longitude));
        if (this.currentMarker == null) {
          this.currentMarker = new google.maps.Marker({
            position: curlnglat,
            map: this.map,
            icon:
              transportType == TransportType.GROUND
                ? this.cabicon
                : {
                    path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                    scale: 6,
                    fillColor: 'red',
                    fillOpacity: 0.8,
                    strokeWeight: 2,
                    rotation: this.prevlnglat != null ? google.maps.geometry.spherical.computeHeading(this.prevlnglat, curlnglat) : 0, //this is how to rotate the pointer
                  },
            title: 'Current location',
          });
          this.latlngbounds.extend(this.currentMarker.position);
          this.map.setCenter(this.latlngbounds.getCenter());
          this.map.fitBounds(this.latlngbounds);
          this.prevlnglat = curlnglat;
        } else {
          this.currentMarker.setPosition(curlnglat);
        }
      }
    });
  }
  drawLegMap(origin, destination, transtype, legId) {
    this.mapInitializer();
    this.currentMarker = null;
    this.legIdList = [];
    if (this.itiMapMarkers && this.itiMapMarkers.length > 0) {
      for (var i = 0; i < this.itiMapMarkers.length; i++) {
        this.itiMapMarkers[i].setMap(null);
      }
    }
    this.LegOrigin = this.serviceOriginLocations.find((x) => x.addressId == origin);
    this.LegDestination = this.serviceDestinationLocations.find((x) => x.addressId == destination);
    this.legIdList.push(legId);
    this._itineraryService.GetOriginAndDestinationLocationByLegIdList(this.legIdList).then((result) => {
      if (result.length > 0) {
        const ocoords = new google.maps.LatLng(
          parseFloat(result[0].originAddressDetail.latitude),
          parseFloat(result[0].originAddressDetail.longitude),
        );
        const dcoords = new google.maps.LatLng(
          parseFloat(result[0].destinationAddressDetail.latitude),
          parseFloat(result[0].destinationAddressDetail.longitude),
        );
        this.markerOrigin = new google.maps.Marker({
          position: ocoords,
          map: this.map,
          label: 'A',
          title: result[0].originAddressDetail.addressName,
        });
        // Creating fence
        this._mapMarkerService.createGeoFence(this.map, ocoords, transtype);
        this.markerDestination = new google.maps.Marker({
          position: dcoords,
          map: this.map,
          label: 'B',
          title: result[0].destinationAddressDetail.addressName,
        });
        // Creating fence
        this._mapMarkerService.createGeoFence(this.map, dcoords, transtype);
        this.directionFinder(result[0].originAddressDetail, result[0].destinationAddressDetail, transtype, legId);
        this.getDistance(this.markerOrigin, this.markerDestination, transtype, false);
        this.startGetLocationInterval(legId, transtype);
      }
    });
  }
  directionFinder(org, des, transType, legId?) {
    const ocoords = { lat: parseFloat(org.latitude), lng: parseFloat(org.longitude) };
    const dcoords = { lat: parseFloat(des.latitude), lng: parseFloat(des.longitude) };
    if (transType == 'Air') {
      let flightActualRoute;

      if (legId) {
        this._flightTrackingService.getFlightRoute(legId).subscribe((flightRouteData: IFlightLocationDetails[]) => {
          flightActualRoute = flightRouteData.map((x) => {
            return {
              lat: parseFloat(x.latitude),
              lng: parseFloat(x.longitude),
            };
          });
          /**
           * @param flightActualRoute : This is an array of actual flight path coordinates
           * @param occords : This is the coordinates of the rogin location
           * @param dccords : This is the coordinates of the destination location
           */

          let newFlightRouteArray = this.prepareFlightRoute(flightActualRoute, ocoords, dcoords);

          new google.maps.Polyline({
            path: newFlightRouteArray,
            map: this.map,
          });
        });
      }
    } else if (transType == 'Ground') {
      const waypts: google.maps.DirectionsWaypoint[] = [];
      var directionsService = new google.maps.DirectionsService();
      var directionsDisplay = new google.maps.DirectionsRenderer();
      var method = 'DRIVING';
      directionsDisplay.setMap(this.map);
      directionsDisplay.setOptions({ suppressMarkers: true });
      directionsService.route(
        {
          origin: { lat: parseFloat(org.latitude), lng: parseFloat(org.longitude) },
          destination: { lat: parseFloat(des.latitude), lng: parseFloat(des.longitude) },
          waypoints: waypts,
          travelMode: google.maps.TravelMode[method],
        },
        function (response, status) {
          if (status === 'OK') {
            directionsDisplay.setDirections(response);
          } else {
            this.toastr.error('Unable to load directions! Please try again.', 'Error', {
              timeOut: 3000,
              positionClass: 'toast-top-center',
            });
          }
        },
      );
    }
  }
  prepareFlightRoute(flightActualRoute, ocoords, dcoords) {
    let newFlightRouteArray = [];
    newFlightRouteArray.push(ocoords);
    newFlightRouteArray = newFlightRouteArray.concat(flightActualRoute);
    newFlightRouteArray.push(dcoords);
    return newFlightRouteArray;
  }
  getDistance(oMkr, dMkr, transtype, isIti) {
    if (transtype == 'Air') {
      const distance = this._mapMarkerService.getFlightDistance(oMkr, dMkr);
      if (isIti == true) {
        this.totalDuration = this.totalDuration + (distance + 431.25) / 575;
        this.totalDistance = this.totalDistance + distance;
        this.distance = this.totalDistance.toFixed(1) + ' miles';
      } else {
        this.distance = distance.toFixed(2) + ' miles';
        let dur = (distance / 575).toFixed(2).toString().split('.');
        this.duration = dur[0] + ' hours ' + (parseFloat(dur[1]) * 0.6).toFixed(0) + ' mins';
      }
    } else {
      var method = 'DRIVING';
      var service = new google.maps.DistanceMatrixService();
      service.getDistanceMatrix(
        {
          origins: [oMkr.position],
          destinations: [dMkr.position],
          travelMode: google.maps.TravelMode[method],
        },
        (response, status) => {
          if (status == 'OK') {
            var origins = response.originAddresses;
            var destinations = response.destinationAddresses;
            for (var i = 0; i < origins.length; i++) {
              var results = response.rows[i].elements;
              for (var j = 0; j < results.length; j++) {
                var element = results[j];
                let dist = element.distance.text.split(' ')[0];
                if (isIti == true) {
                  this.totalDuration = this.totalDuration + element.duration.value / 3600;
                  let dur = this.totalDuration.toFixed(2).split('.');
                  this.duration = dur[0] + ' hours ' + (parseFloat(dur[1]) * 0.6).toFixed(0) + ' mins';
                  this.totalDistance = this.totalDistance + parseFloat(dist.replace(/,/g, '')) / 1.609;
                  this.distance = this.totalDistance.toFixed(1) + ' miles';
                } else {
                  this.distance = (parseFloat(dist.replace(/,/g, '')) / 1.609).toFixed(1) + ' miles';
                  this.duration = element.duration.text;
                }
              }
            }
          }
        },
      );
    }
  }
  carouselTileLoad() {
    let ele = Array.from(document.getElementsByClassName('ngucarousel-items') as HTMLCollectionOf<HTMLElement>);
    if (ele.length > 0) {
      ele[0].style.marginLeft = '50px';
      ele[0].style.marginRight = '50px';
    }
    this.carouselTileItems = this.carouselList;
  }
  getAllServiceLocations() {
    if (this._locationService.serviceLocationList$.value.length > 0) {
      this.setServiceLocations(this._locationService.serviceLocationList$.value);
    } else {
      this._locationService.getAllServiceLocations().subscribe((response) => {
        this.setServiceLocations(response);
      });
    }
  }
  private setServiceLocations(response: IGetLocationViewModel[]) {
    this.serviceOriginLocations = response;
    this.serviceDestinationLocations = response;
    const srIdList = {
      serviceRequestId: [this.serviceRequestId],
    };
    this.getLegDetail(srIdList);
  }

  getServiceTypes() {
    if (this._serviceRequestService.srServiceTypeList$.value.length > 0) {
      this.setServiceTypeList(this._serviceRequestService.srServiceTypeList$.value);
    } else {
      this._serviceRequestService.getServiceTypes().subscribe((response) => {
        this.setServiceTypeList(response);
      });
    }
  }
  private setServiceTypeList(serviceTypeList: ServiceType[]) {
    this.serviceTypes = serviceTypeList;
    const serviceType = serviceTypeList.find((x) => x.serviceTypeName == this.ServiceList.serviceInfo.serviceType);
    if (serviceType) {
      this.serviceTypeId = serviceType.serviceTypeId;
    }
  }

  getLegDetail(id) {
    this.legPlannedDuration = [];
    this.legActualDuration = [];
    this.estimatedSourceTime = 0;
    this.actualSourceTime = 0;
    this.estimatedDestinationTime = 0;
    this.actualDestinationTime = 0;
    this._serviceRequestService.getLegDetail(id).subscribe((response) => {
      this.legList = response;
      this.legList = this.legList.sort((a, b) => {
        let x = new Date(a.plannedStartTime);
        let y = new Date(b.plannedStartTime);

        if (Number(x) > Number(y)) return 1;
        if (Number(x) < Number(y)) return -1;
        return 0;
      });
      this.legList.forEach((element) => {
        let duration = this.calculateDiff(element.plannedStartTime, element.plannedEndTime);
        this.legPlannedDuration.push(duration);
        if (element.actualStartTime != null && element.actualEndTime != null) {
          let duration2 = this.calculateDiff(element.actualStartTime, element.actualEndTime);
          this.legActualDuration.push(duration2);
        }
      });
      let outBoundLeg = this.legList.filter((x) => x.direction == 'Outbound');
      let inBoundLeg = this.legList.filter((x) => x.direction == 'Inbound');
      outBoundLeg.forEach((item) => {
        this.estimatedSourceTime = this.estimatedSourceTime + this.calculateMin(item.plannedStartTime, item.plannedEndTime);
      });
      if (
        outBoundLeg.every((x) => x.status == 'Job Done' || x.status == 'Dropped Off' || x.status == 'Driver Done' || x.status == 'Landed')
      ) {
        outBoundLeg.forEach((item) => {
          this.actualSourceTime = this.actualSourceTime + this.calculateMin(item.actualStartTime, item.actualEndTime);
        });
      }
      inBoundLeg.forEach((item) => {
        this.estimatedDestinationTime = this.estimatedDestinationTime + this.calculateMin(item.plannedStartTime, item.plannedEndTime);
      });
      if (
        inBoundLeg.every((x) => x.status == 'Job Done' || x.status == 'Dropped Off' || x.status == 'Driver Done' || x.status == 'Landed')
      ) {
        inBoundLeg.forEach((item) => {
          this.actualDestinationTime = this.actualDestinationTime + this.calculateMin(item.actualStartTime, item.actualEndTime);
        });
      }

      this.legListCount = this.legList.length;
      this.onShowFullMapClick();
    });
  }
  calculateDiff(a, b) {
    var date1 = new Date(a);
    var date2 = new Date(b);
    date1.setSeconds(0);
    date2.setSeconds(0);
    var diffTime = Math.abs(date2.getTime() - date1.getTime());
    let duration = this.convertToHourMinutes(diffTime / (1000 * 60));
    return duration;
  }
  convertToHourMinutes(time) {
    var hours: any = Math.floor(time / 60);
    var minutes: any = Math.floor(time - (hours * 3600) / 60);
    if (hours < 10) {
      hours = '0' + hours;
    }
    if (minutes < 10) {
      minutes = '0' + minutes;
    }
    let duration = '' + hours + ' h ' + minutes + ' m';
    return duration;
  }
  calculateMin(a, b) {
    var date1 = new Date(a);
    var date2 = new Date(b);
    date1.setSeconds(0);
    date2.setSeconds(0);
    var diffTime = Math.abs(date2.getTime() - date1.getTime());
    return diffTime / (1000 * 60);
  }

  getServiceRequestDetail(serviceRequestId) {
    this.loader = true;
    this._serviceRequestService.getServiceRequestData(serviceRequestId).subscribe({
      next: (response) => {
        this.ServiceList = response;
        this.getServiceTypes();
        this.actualDoorToDoorTime = this.calculateDiff(this.ServiceList.createdOn, this.ServiceList.serviceInfo.actualEndTime);
        this.teamDetails = this.ServiceList['serviceInfo']['teamDetails'];
        this.planEndTime = this.ServiceList.serviceInfo.plannedEndTime;
        this.actualEndTime = this.ServiceList.serviceInfo.actualEndTime;
        this.customerContactId = this.ServiceList.customerInfo['contactId'];
        this.loader = false;
        this.serviceType = this.ServiceList.serviceInfo.serviceType;
        this.start_Time = this._datepipe.transform(this.ServiceList.serviceInfo.startTime, 'MM/dd/yyyy HH:mm');
        this.scheduledArrivalTime = this._datepipe.transform(this.ServiceList.serviceInfo.scheduledArrivalTime, 'MM/dd/yyyy HH:mm');
        this.end_Time = this._datepipe.transform(this.ServiceList.serviceInfo.plannedEndTime, 'MM/dd/yyyy HH:mm');
        this.value = this.ServiceList.serviceInfo['orTime'];
        this.ortime = this._datepipe.transform(this.value, 'MM/dd/yyyy HH:mm');
        this.isCode3 = this.ServiceList.serviceInfo.isCode3;
        if (this.isCode3) {
          this.serviceisCode3 = 'Yes';
        } else if (this.isCode3 == null) {
          this.serviceisCode3 = 'NA';
        } else {
          this.serviceisCode3 = 'No';
        }
        this.customerSelectedId = this.ServiceList.customerInfo['businessUnitId'];
        this.customerSelected = this.ServiceList['customerInfo'];
        this.notes = this.ServiceList.note;
        let origin = this.ServiceList.tripInfo;
        const source = {
          Name: origin['origin'],
          Address1: origin['originAddress'],
          Address2: origin['originAddressLocation'],
          Contact: origin['originCurrentCustomerPhoneNumber'] || origin['originContactNumber'],
          ContactName: origin['originCurrentCustomerName'] || origin['originContactName'],
        };
        this.carouselList.push(source);
        let deslist = this.ServiceList.serviceInfo.destination;
        deslist.forEach((des) => {
          let obj = {
            Name: des['destination'],
            Address1: des['destinationAddress'],
            Address2: des['destinationAddressLocation'],
            Contact: des['destinationPhoneNumber'],
            ContactName: des['destinationMember'],
          };
          this.carouselList.push(obj);
        });
        this.loader = false;
        this.specialInstructions = this.ServiceList.tripInfo.specialInstruction;
        this.SpecialInstructionCount = this.specialInstructions.length;
        this.createdOn = this._datepipe.transform(this.ServiceList.createdOn, 'MM/dd/yyyy HH:mm');
        this.currentOrigin = this.ServiceList.tripInfo.originAddressID;
        this.currentDestination = this.ServiceList.serviceInfo.destination[0]['destinationAddressID'];
      },
      error: (err) => {
        this._toastr.warning('Something went wrong! Please try again', 'Warning', {
          timeOut: 6000,
          positionClass: 'toast-top-center',
        });
        this.loader = false;
      },
    });
  }

  onShowFullMapClick() {
    let itiMapDetails = [];
    if (this.legList.length > 0) {
      this.legList.forEach((el) => {
        let legObj = {
          origin: el.originId,
          destination: el.destinationId,
          transportType: el.transportType,
        };
        itiMapDetails.push(legObj);
      });
    } else {
      let legObj = {
        origin: this.currentOrigin,
        destination: this.currentDestination,
        transportType: 'Ground',
      };
      itiMapDetails.push(legObj);
    }
    this.drawItineraryMap(itiMapDetails);
  }
  private drawItineraryMap(itiMapDetails) {
    this.totalDistance = 0;
    this.totalDuration = 0;
    this.reinitializeGetLocationSubscription();
    this.mapInitializer();
    let itiMapLocs = [];
    if (this.markerOrigin) {
      this.markerOrigin.setMap(null);
    }
    if (this.markerDestination) {
      this.markerDestination.setMap(null);
    }
    this.itiMapMarkers.forEach((el) => {
      el.setMap(null);
    });
    this.itiMapMarkers = [];
    if (itiMapDetails && itiMapDetails.length > 0) {
      let org = this.serviceDestinationLocations.find((x) => x.addressId == itiMapDetails[0].origin);
      if (!org) {
        return;
      }
      itiMapLocs.push(org);
      let mrk = new google.maps.Marker({
        position: new google.maps.LatLng(parseFloat(org.latitude), parseFloat(org.longitude)),
        map: this.map,
        label: this.labels[this.itiMapMarkers.length % this.labels.length],
        title: org.addressName,
      });
      this.itiMapMarkers.push(mrk);
      for (var i = 0; i < itiMapDetails.length; i++) {
        let des = this.serviceDestinationLocations.find((x) => x.addressId == itiMapDetails[i].destination);
        if (!des) {
          continue;
        }
        itiMapLocs.push(des);
        let mrk2 = new google.maps.Marker({
          position: new google.maps.LatLng(parseFloat(des.latitude), parseFloat(des.longitude)),
          map: this.map,
          label: this.labels[this.itiMapMarkers.length % this.labels.length],
          title: des.addressName,
        });
        this.itiMapMarkers.push(mrk2);
      }
      for (var i = 1; i < itiMapLocs.length; i++) {
        this.directionFinder(itiMapLocs[i - 1], itiMapLocs[i], itiMapDetails[i - 1].transportType);
      }
      for (var i = 1; i < this.itiMapMarkers.length; i++) {
        this.getDistance(this.itiMapMarkers[i - 1], this.itiMapMarkers[i], itiMapDetails[i - 1].transportType, true);
      }
      let dur = this.totalDuration.toFixed(2).split('.');
      this.duration = dur[0] + ' hours ' + (parseFloat(dur[1]) * 0.6).toFixed(0) + ' mins';
      this.distance = this.totalDistance.toFixed(1) + ' miles';
    }
  }

  updateNotesType(type) {
    this.notesType = type;
  }

  download() {
    this.nameOfFile = this.ServiceList.tripId;
    Constant.selectedMenu = this.nameOfFile + '_Itinerary';
    this.showHideAll('Expand All');
    setTimeout(() => {
      Constant.download('contentAbc');
    }, 2000);
  }

  openFlightAware(tailNumber: any) {}
  openTeamMemberDetailsModal(memberDetails) {
    if (this.user.businessUnitId == this.internalMemberBusinessUnitId) {
      this.teamMemberDetails = {
        memberName: memberDetails.memberName,
        phoneNumber: memberDetails.phoneNumber,
        dob: this._datepipe.transform(memberDetails.dob, 'MM/dd/yyyy'),
        weight: memberDetails.weight,
        memberAddress: memberDetails.memberAddress,
        gender: memberDetails.gender,
      };
    }
  }
  openCheckListDetails() {
    const checkListModel: IGetCheckListModel = {
      serviceType: this.ServiceList.serviceInfo.serviceType,
      memberId: this.customerSelectedId,
      serviceRequestId: this.serviceRequestId,
    };
    let checklistDialogRef = this._dialog.open(CheckListDetailsComponent, {
      width: '100rem',
      position: {
        top: '4rem',
      },
      data: checkListModel,
    });
    checklistDialogRef.afterClosed().subscribe(() => {
      this._checklistService.triggerGetChekListLogMethod.next(this.serviceRequestId);
    });
  }
  togglePopOver() {
    $(document).ready(function () {
      $('[data-toggle="popover"]').popover();
    });
  }

  private getUserTimezone(): void {
    if (this.timezoneService.selectedTimezone) {
      this.selectedTimezone = this.timezoneService.selectedTimezone;
      this.selectTimeZone({ value: this.selectedTimezone });
    } else {
      this.detectUserTimezone();
    }
  }

  private detectUserTimezone(): void {
    const detectUserTimezone = this.timezoneHttpService
      .detectUserTimezone()
      .pipe(first())
      .subscribe((response: UserTimezoneInterface): void => {
        if (response) {
          const timezone = this.timezoneService.timezones.get(response.name) ?? this.timezoneService.timezones.get(TimezoneShortEnum.MST);

          this.selectTimeZone({ value: timezone });
        } else {
          this.selectedTimezone = this.timezoneService.timezones.get(TimezoneShortEnum.MST);
        }
      });

    this._subscriptions.add(detectUserTimezone);
  }

  directionColor(status: string | null): string {
    if (!status) return '';
    return status.toLowerCase() === 'outbound' ? 'dir-outbound' : 'dir-inbound';
  }
}
